export default __webpack_public_path__ + "static/media/soldering.871db6fd.png";